import { SxProps } from '@mui/material';

export const getCountSx = (unsyncedCount: number): SxProps => ({
  fontSize: '24px',
  color: unsyncedCount === 0 ? '#000000' : '#d32f2f',
  marginTop: 0,
  lineHeight: 1
});

export const LinkSx: SxProps = {
  fontSize: '14px',
  textDecoration: 'underline',
  color: '#000000',
  '&:hover': {
    textDecoration: 'underline'
  }
};

export const ParenthesesSx: SxProps = {
  color: '#000000'
};

export const TitleContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 0.5
};

export const TitleTextSx: SxProps = {
  fontSize: '14px',
  color: 'text.secondary',
  fontWeight: 500,
  marginBottom: 0.5,
  lineHeight: 1
};

export const CountContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 1,
  flexWrap: 'nowrap'
};

export const SpinnerSx: SxProps = {
  color: 'grey.500',
  width: '20px !important',
  height: '20px !important'
}; 
